// removed by extract-text-webpack-plugin
module.exports = {"PayButtonContainer":"Form__PayButtonContainer__2z9R8","CardElementContainer":"Form__CardElementContainer__12P5W","Title":"Form__Title__A-Fjd","Description":"Form__Description__12IWO","LabelCaparra":"Form__LabelCaparra__1l0-o","LabelPrice":"Form__LabelPrice__1ixDJ","ErrorText":"Form__ErrorText__thmZi","StripeElement":"Form__StripeElement__32lGK","StripeElementCardNumber":"Form__StripeElementCardNumber__1rZZZ","StripeElementMonth":"Form__StripeElementMonth__UYDyt","StripeElementCvc":"Form__StripeElementCvc__4jSLD"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/BookingFlow/Form.css
// module id = 72
// module chunks = 0